import { store } from '../store.js'

export const flashPlugin = {
  install: (app) => {
    app.config.globalProperties.$updateFlash = (payload) => {
      store.dispatch('flash/updateFlash', payload)
    }
    app.config.globalProperties.$clearFlash = () => {
      store.dispatch('flash/clearFlash')
    }
  }
}
